/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum SulphurTargetPh {
    Ph55 = "Ph55",
    Ph65 = "Ph65"
}

export default SulphurTargetPh;
